<template>
  <div class="privacy-wrapper">
    <h1>{{ $t('common.privacy_policy') }}</h1>
    <div class="content-block">
      <div v-html="$t('privacy_policy_text')"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MetaHeadMixin from '@/dependencies/mixins/meta-head'

export default {
  name: 'Privacy',
  mixins: [MetaHeadMixin],
  computed: {
    ...mapGetters({
      cityDomain: 'seo/getSelectedCity'
    }),
    domain() {
      return this.cityDomain?.domainTitle
    },
    metaTitle() {
      return `${this.$t('common.privacy_policy')} - ${this.domain}`
    }
  }
}
</script>

<style scoped lang="scss">
@import '~assets/css/variables';

.privacy-wrapper {
  h1 {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #595959;
    padding: 15px 0;
  }
}

.content-block {
  padding: 10px;
}

@media (min-width: 768px) {
  .privacy-wrapper {
    background-color: #e6e6e6;
    padding-bottom: 100px;

    h1 {
      font-size: 38px;
      padding: 40px 0;
    }
  }

  .content-block {
    margin: 0 auto;
    background-color: #ffffff;
    max-width: 1180px;
    padding: 30px;
  }
}
</style>
